
import React, { useState } from 'react';
import { Button } from '../../../components/base/Button';

export const ContactSection: React.FC = () => {
  const [activeTab, setActiveTab] = useState('contact');

  return (
    <section id="contact" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            <strong>聯絡我們</strong>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            歡迎聯絡焯峯工程，我們的專業團隊將為您提供最適合的<strong>工程服務解決方案</strong>
          </p>
        </div>

        <div className="mb-12">
          <div className="flex justify-center">
            <div className="bg-white rounded-full p-1 shadow-sm">
              <button
                onClick={() => setActiveTab('contact')}
                className={`px-6 py-2 rounded-full font-medium transition-all whitespace-nowrap ${
                  activeTab === 'contact'
                    ? 'bg-red-600 text-white'
                    : 'text-gray-600 hover:text-red-600'
                }`}
              >
                聯絡資訊
              </button>
              <button
                onClick={() => setActiveTab('location')}
                className={`px-6 py-2 rounded-full font-medium transition-all whitespace-nowrap ${
                  activeTab === 'location'
                    ? 'bg-red-600 text-white'
                    : 'text-gray-600 hover:text-red-600'
                }`}
              >
                辦公地點
              </button>
              <button
                onClick={() => setActiveTab('consultation')}
                className={`px-6 py-2 rounded-full font-medium transition-all whitespace-nowrap ${
                  activeTab === 'consultation'
                    ? 'bg-red-600 text-white'
                    : 'text-gray-600 hover:text-red-600'
                }`}
              >
                預約諮詢
              </button>
            </div>
          </div>
        </div>

        {activeTab === 'contact' && (
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            <div>
              <div className="bg-white rounded-2xl p-8 shadow-lg">
                <h3 className="text-2xl font-bold text-gray-900 mb-6">聯絡資訊</h3>
                
                <div className="space-y-6">
                  <div className="flex items-center">
                    <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center mr-4">
                      <i className="ri-map-pin-line text-red-600 text-xl"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900">地址</h4>
                      <p className="text-gray-600">香港九龍新蒲崗大有街3號萬迪廣場15樓J室</p>
                    </div>
                  </div>
                  
                  <div className="flex items-center">
                    <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center mr-4">
                      <i className="ri-phone-line text-red-600 text-xl"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900">電話</h4>
                      <p className="text-gray-600">+852 9189 8819</p>
                    </div>
                  </div>
                  
                  <div className="flex items-center">
                    <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center mr-4">
                      <i className="ri-mail-line text-red-600 text-xl"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900">電郵</h4>
                      <p className="text-gray-600">info@cfengineering.com.hk</p>
                    </div>
                  </div>
                  
                  <div className="flex items-center">
                    <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center mr-4">
                      <i className="ri-time-line text-red-600 text-xl"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900">營業時間</h4>
                      <p className="text-gray-600">星期一至五 9:00-18:00</p>
                    </div>
                  </div>
                </div>
                
                <div className="mt-8">
                  <Button 
                    className="w-full"
                    onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
                  >
                    <i className="ri-phone-line mr-2"></i>
                    立即致電諮詢
                  </Button>
                </div>
              </div>
            </div>
            
            <div>
              <div className="bg-white rounded-2xl p-8 shadow-lg">
                <h3 className="text-2xl font-bold text-gray-900 mb-6">即時諮詢</h3>
                
                <div className="text-center py-12">
                  <div className="mb-8">
                    <i className="ri-whatsapp-line text-6xl text-green-500 mb-4"></i>
                    <h4 className="text-xl font-semibold text-gray-900 mb-2">WhatsApp 即時諮詢</h4>
                    <p className="text-gray-600">點擊下方按鈕，立即透過WhatsApp與我們聯絡</p>
                  </div>
                  
                  <a 
                    href="https://wa.me/85291898819"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center w-full bg-green-500 hover:bg-green-600 text-white font-semibold py-4 px-6 rounded-lg transition-colors cursor-pointer"
                  >
                    <i className="ri-whatsapp-line mr-2 text-xl"></i>
                    WhatsApp 諮詢
                  </a>
                  
                  <div className="mt-6 text-sm text-gray-500">
                    <p>或直接撥打：+852 9189 8819</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'location' && (
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            <div>
              <div className="bg-white rounded-2xl p-8 shadow-lg">
                <h3 className="text-2xl font-bold text-gray-900 mb-6">辦公地點</h3>
                
                <div className="mb-6">
                  <h4 className="font-semibold text-gray-900 mb-2">焯峯工程有限公司</h4>
                  <p className="text-gray-600 mb-4">香港九龍新蒲崗大有街3號萬迪廣場15樓J室</p>
                  
                  <div className="space-y-3 text-sm text-gray-600">
                    <div className="flex items-center">
                      <i className="ri-subway-line text-red-600 mr-2"></i>
                      <span>港鐵：鑽石山站A2出口，步行約8分鐘</span>
                    </div>
                    <div className="flex items-center">
                      <i className="ri-bus-line text-red-600 mr-2"></i>
                      <span>巴士：多條路線經大有街，交通便利</span>
                    </div>
                    <div className="flex items-center">
                      <i className="ri-car-line text-red-600 mr-2"></i>
                      <span>自駕：大廈設有停車場</span>
                    </div>
                  </div>
                </div>
                
                <div className="border-t pt-6">
                  <h4 className="font-semibold text-gray-900 mb-3">服務範圍</h4>
                  <div className="grid grid-cols-2 gap-2 text-sm text-gray-600">
                    <div>• 香港島</div>
                    <div>• 九龍</div>
                    <div>• 新界東</div>
                    <div>• 新界西</div>
                  </div>
                </div>
              </div>
            </div>
            
            <div>
              <div className="bg-white rounded-2xl p-8 shadow-lg">
                <h3 className="text-2xl font-bold text-gray-900 mb-6">地圖位置</h3>
                
                <div className="mb-6">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3691.8234567890123!2d114.20123456789012!3d22.334567890123456!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjLCsDIwJzA0LjQiTiAxMTTCsDEyJzA0LjQiRQ!5e0!3m2!1sen!2shk!4v1234567890123"
                    width="100%"
                    height="300"
                    style={{ border: 0 }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    className="rounded-lg"
                  ></iframe>
                </div>
                
                <div className="text-center">
                  <a
                    href="https://maps.google.com/?q=香港九龍新蒲崗大有街3號萬迪廣場"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center bg-red-600 hover:bg-red-700 text-white font-semibold py-3 px-6 rounded-lg transition-colors cursor-pointer"
                  >
                    <i className="ri-map-pin-line mr-2"></i>
                    在Google地圖中查看
                  </a>
                </div>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'consultation' && (
          <div className="max-w-4xl mx-auto">
            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">預約免費諮詢</h3>
              
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
                <div className="text-center">
                  <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-phone-line text-red-600 text-2xl"></i>
                  </div>
                  <h4 className="font-semibold text-gray-900 mb-2">電話預約</h4>
                  <p className="text-gray-600 text-sm mb-4">致電我們預約面談時間</p>
                  <a 
                    href="tel:+85291898819"
                    className="text-red-600 hover:text-red-700 font-medium cursor-pointer"
                  >
                    +852 9189 8819
                  </a>
                </div>
                
                <div className="text-center">
                  <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-whatsapp-line text-green-600 text-2xl"></i>
                  </div>
                  <h4 className="font-semibold text-gray-900 mb-2">WhatsApp預約</h4>
                  <p className="text-gray-600 text-sm mb-4">透過WhatsApp快速預約</p>
                  <a 
                    href="https://wa.me/85291898819"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-green-600 hover:text-green-700 font-medium cursor-pointer"
                  >
                    立即聯絡
                  </a>
                </div>
                
                <div className="text-center">
                  <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-customer-service-line text-blue-600 text-2xl"></i>
                  </div>
                  <h4 className="font-semibold text-gray-900 mb-2">AI語音助手</h4>
                  <p className="text-gray-600 text-sm mb-4">24小時智能預約服務</p>
                  <button 
                    onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
                    className="text-blue-600 hover:text-blue-700 font-medium cursor-pointer"
                  >
                    開始對話
                  </button>
                </div>
              </div>
              
              <div className="bg-gray-50 rounded-xl p-6">
                <h4 className="font-semibold text-gray-900 mb-4">諮詢服務包括：</h4>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="flex items-center">
                    <i className="ri-check-line text-green-600 mr-2"></i>
                    <span className="text-gray-700">村屋僭建物申報評估</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-check-line text-green-600 mr-2"></i>
                    <span className="text-gray-700">適任技術人員服務諮詢</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-check-line text-green-600 mr-2"></i>
                    <span className="text-gray-700">工程項目可行性分析</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-check-line text-green-600 mr-2"></i>
                    <span className="text-gray-700">屋宇署申報程序指導</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-check-line text-green-600 mr-2"></i>
                    <span className="text-gray-700">工程費用預算評估</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-check-line text-green-600 mr-2"></i>
                    <span className="text-gray-700">法規合規性檢查</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};
